'use strict';
import {EwSiteApp} from '../../app/ewsiteapp';

export function ProblemsMap(params) {
	if (typeof(params.default_coordinates.lat) !== 'number' && typeof(params.default_coordinates.lng) !== 'number'){
		console.log('no default coordinates');
		return false;
	}
	
	if (params.single_view){
	}
	else if (typeof(params.data_url) !== 'string' || params.data_url == ''){
		console.log('no data_url');
		return false;
	}
	
	var innerPrivate = {
		map: {},
		markers: [],
		items: [],
		infowindow: {}
	};
	var self = this;
	
	
	innerPrivate.init = function(){
		innerPrivate.map = new google.maps.Map(document.getElementById('problemsmap'), {
			zoom: params.zoom,
			center: params.default_coordinates,
			scrollwheel: false
		});
		
		if (params.single_view){
			var $map = $("#problemsmap");
			innerPrivate.markers[1] = new google.maps.Marker({
				id: 1,
				position: new google.maps.LatLng($map.data("lat"), $map.data("long")),
				map: innerPrivate.map,
				icon: $map.data("themedir") + 'img/problem_pin_'+$map.data("type")+'.png'
			});
		}
		else{
			innerPrivate.getProblemList();
		}
		
		$('#categories_select').change(function(e){
			innerPrivate.showMarkersByType(this.value);
		});
	};
	
	innerPrivate.getProblemList = function(){
		$.ajax({
			url: params.data_url,
			type: 'GET',
			success:function(resp) {
				if(resp.success){
					innerPrivate.items = resp.data;
					innerPrivate.showProblems();
				}
			},
			error: function(){
				alert('Load error.');
			}
		});
	};
	
	innerPrivate.showProblems = function(){
		var $map = $("#problemsmap");
		for(var i in innerPrivate.items){
			var item = innerPrivate.items[i];
			var id = parseInt(item.id);
			
			innerPrivate.markers[id] = new google.maps.Marker({
				id: i,
				problem_id: id,
				position: new google.maps.LatLng(item.lat, item.lng),
				map: innerPrivate.map,
				title: item.address + ' ('+item.status_title+')',
				icon: $map.data("themedir") + 'img/problem_pin_'+item.status_meta.class+'.png',
				problem_type_id: parseInt(item.type_id)
			});
			
			innerPrivate.markers[id].addListener('click', function() {
				var id = this.id;
				innerPrivate.closeInfoWindow();
				innerPrivate.infowindow = new google.maps.InfoWindow({
					content: innerPrivate.getProblemHtml(innerPrivate.items[id])
				});
				innerPrivate.infowindow.open(innerPrivate.map, this);
				innerPrivate.infowindow.problem_id = this.problem_id;
				innerPrivate.infowindow.problem_type_id = this.problem_type_id;
			});
		}
	};
	
	innerPrivate.showMarkersByType = function(type_id){
		type_id = parseInt(type_id) || 0;
		
		innerPrivate.closeInfoWindow(type_id);
		
		for(var id in innerPrivate.markers){
			var marker = innerPrivate.markers[id];
			marker.setVisible(type_id === 0 || type_id === marker.problem_type_id);
		}
	};
	
	innerPrivate.closeInfoWindow = function(except_type_id){
		except_type_id = typeof(except_type_id) === 'undefined' ? -1 : parseInt(except_type_id);
		if (typeof(innerPrivate.infowindow.close) === 'function' && except_type_id !== 0 && innerPrivate.infowindow.problem_type_id !== except_type_id ) {
			innerPrivate.infowindow.close();
		}
	};

	innerPrivate.getProblemHtml = function(item){
		return '<div><strong>'+item.description+'</strong> ('+item.status_title+')<br/>'+item.type_title+'<br/>'+innerPrivate.formatDate(item.created)+'</div><div>'+item.address+'</div><div><a href="'+item.view_url+'">'+innerPrivate.getT('problemsmap_view_item')+'</div>';
	};
	
	innerPrivate.getT = function(key){
		if(typeof(params.t[key]) === 'string'){
			return params.t[key];
		}
		return '*'+key+'*';
	};
	
	innerPrivate.formatDate = function(timestamp){
		var d = new Date(timestamp*1000);
		
		var hours = d.getHours();
		var month = "0" + (d.getMonth()+1);
		var minutes = "0" + d.getMinutes();
		var seconds = "0" + d.getSeconds();

		// Will display time in 10:30:23 format
		return d.getFullYear()+'-'+month .substr(-2)+'-'+d.getDate()+' '+hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
	};

	
	innerPrivate.init();
}

function ProblemsMapRegister(params) {
	var $container = $('#problemsmap_form');
	var innerPrivate = {
		map: {},
		marker: false,
		geocoder: {},
		$address: $('#problem_address', $container),
		$lat: $('#problem_lat', $container),
		$lng: $('#problem_lng', $container)
	};
	var self = this;
	
	
	innerPrivate.init = function(){
		$container.on('submit', innerPrivate.onFormSubmit);
		$container.on('click', '.add_file', innerPrivate.addFile);
		
		innerPrivate.map = new google.maps.Map(document.getElementById('problemsmap'), {
			zoom: params.zoom,
			center: params.default_coordinates,
			scrollwheel: false
		});
		innerPrivate.geocoder = new google.maps.Geocoder;
		
		google.maps.event.addListener(innerPrivate.map, 'click', function(event){
			innerPrivate.addMarker(event.latLng);
		});
		
		var lat = parseFloat(innerPrivate.$lat.val());
		var lng = parseFloat(innerPrivate.$lng.val());
		if(!isNaN(lat) && !isNaN(lng)){
			var point = new google.maps.LatLng(lat, lng);
			innerPrivate.map.panTo(point);
			innerPrivate.addMarker(point);
		}
	};
	
	innerPrivate.addMarker = function(location) {
		if(!innerPrivate.marker){
			innerPrivate.marker = new google.maps.Marker({
				draggable: true,
				position: location,
				//title: '',
				map: innerPrivate.map
			});
			google.maps.event.addListener(innerPrivate.marker, 'click', function(event){
				innerPrivate.setProblemLatLng(event.latLng);
			});
			google.maps.event.addListener(innerPrivate.marker, 'dragend', function(event){
				innerPrivate.setProblemLatLng(event.latLng);
			});
		}
		
		innerPrivate.marker.setPosition(location);
		innerPrivate.setProblemLatLng(location);
	};
	
	
	innerPrivate.setProblemLatLng = function(latlng){
		innerPrivate.$lat.val(latlng.lat());
		innerPrivate.$lng.val(latlng.lng());
		
		innerPrivate.setProblemAddressFromLatLng(latlng);
	};
	
	innerPrivate.setProblemAddressFromLatLng = function(latlng){
		innerPrivate.geocoder.geocode({location: latlng}, function(results, status) {
			if (status === 'OK') {
				if (results[0]) {
					innerPrivate.$address.val(results[0].formatted_address);
					
				} else {
					//window.alert('No results found');
				}
			} else {
				//window.alert('Geocoder failed due to: ' + status);
			}
		});
	};
	
	innerPrivate.onFormSubmit = function(e){
		if ($.trim(innerPrivate.$lat.val()) === '' || $.trim(innerPrivate.$lng.val()) === ''){
			alert(innerPrivate.getT('problemsmap_point_not_selected'));

			e.preventDefault();
			return false;
		}
		
		return true;
	};
	
	innerPrivate.addFile = function(e){
		e.preventDefault();
		$(".files_block", $container).children('.file:not(:visible)').first().show();
		
		if ($(".files_block", $container).children('.file:not(:visible)').length === 0){
			$(this).closest('.add_file_wrp').hide();
		}
	};

	innerPrivate.getT = function(key){
		if(typeof(params.t[key]) === 'string'){
			return params.t[key];
		}
		return '*'+key+'*';
	};
	
	innerPrivate.init();
}

EwSiteApp.controller('problemsmapRegisterCtrl', ['$scope', function($scope){
	$scope.form;
	$scope.submitted = false;
	
	$scope.formSubmit = function(e){
		e.preventDefault();
		$scope.submitted = true;
		let is_grecaptcha = $scope.form.find('#g-recaptcha-response-hidden').length > 0;
		if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
			grecaptcha.ready(function () {
				grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action: 'submit'}).then(function (token) {
					if (document.getElementById('g-recaptcha-response-hidden')) {
						$('#g-recaptcha-response-hidden').val(token);
					} else {
						var inp = document.createElement('input');
						inp.type = 'hidden';
						inp.name = 'g-recaptcha-response';
						inp.value = token;
						$scope.form[0].appendChild(inp);
					}
					$scope.form[0].submit();
				});
			});
		} else {
			$scope.form[0].submit();
		}
	};
}]).directive('problemsmapSubmit', function(){
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});

window.ProblemsMap = ProblemsMap;
window.ProblemsMapRegister = ProblemsMapRegister;